import React from 'react';
import { useNavigate } from 'react-router-dom';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { MODES, CHAT_MODE_KEY, readStoredMode } from './ModeSelector';
import '../Assets/css/ChatUI.css';

// Everything that belongs to the current conversation
const CHAT_STORAGE_KEYS = [
  'chatHistory', 'conversation_history', 'references', 'responsePending',
  'initialFetchDone', 'question', 'askedQuestion',
];

export const NEW_CHAT_EVENT = 'cmf:new-chat';

// Clears the conversation and tells the home page to reset (it may already be mounted)
export const startNewChat = (mode) => {
  try {
    CHAT_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
    if (mode) localStorage.setItem(CHAT_MODE_KEY, mode);
  } catch (e) {
    // storage unavailable - navigation below still resets the page
  }
  window.dispatchEvent(new CustomEvent(NEW_CHAT_EVENT, { detail: { mode: mode || readStoredMode() } }));
};

// Sidebar content for signed-in (non-admin) users
const ChatMenu = ({ onClose }) => {
  const navigate = useNavigate();

  const handleNewChat = (mode) => {
    startNewChat(mode);
    navigate('/home');
    onClose?.();
  };

  return (
    <div className="chat-menu">
      <button type="button" className="new-chat-button" onClick={() => handleNewChat()}>
        <AddRoundedIcon sx={{ fontSize: 22 }} />
        New chat
      </button>

      <div className="chat-menu-label">Start a new chat in</div>
      {MODES.map((mode) => (
        <button key={mode.value} type="button" className="chat-menu-item" onClick={() => handleNewChat(mode.value)}>
          <span className="chat-menu-icon">{mode.icon}</span>
          <span>
            <span className="chat-menu-title">{mode.label}</span>
            <span className="chat-menu-description">{mode.tooltip}</span>
          </span>
        </button>
      ))}

      <div className="chat-menu-about">
        <strong>Cloud Migration Assistant</strong>
        Answers from your migration runbooks, DR and cutover documents, reviews plans and inventories, and generates validated Terraform for Azure, AWS and GCP.
      </div>
    </div>
  );
};

export default ChatMenu;
